import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { createUseStyles } from 'react-jss';

import { Separator } from '../../products/common/separator';
import { ReviewNoticeCard } from '../common/review_notice_card';
import { FindInsurerNotice } from '../common/find_insurer_notice';
import { ProviderLogoGrid } from '../common/provider_logo_grid';
import { NoQuotesSummary } from '../common/no_quotes_summary';
import { AlexanderNoResults } from '../common/alexander_no_results';

const useStyles = createUseStyles((theme) => ({
    topContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        height: '22.5rem'
    },
    topLeftContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    noQuotesSummaryContainer: {
        width: '100%'
    },
    title: {
        fontWeight: theme.fontWeight.bold,
        fontSize: theme.fontSize['5xl'],
        color: theme.colors.primary800
    },
    subTitle: {
        fontSize: theme.fontSize['3xl']
    },
    alexander: {
        width: '20.4rem',
        height: '100%'
    },
    reviewNoticeCardContainer: {
        width: '92.5rem',
        height: '11.4rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    reviewNoticeCardText: {
        fontSize: theme.fontSize.xl,
        fontWeight: theme.fontWeight.normal,
        color: theme.colors.grey800,
        lineHeight: '2.5rem'
    },
    separator: {
        marginTop: '3.2rem',
        marginBottom: '3.3rem'
    },
    findInsurerNoticeContainer: {
        marginTop: '2.4rem',
        textAlign: 'left'
    },
    logoTitle: {
        textAlign: 'left',
        color: theme.colors.grey800,
        fontSize: theme.fontSize.lg,
        fontWeight: theme.fontWeight.semibold,
        marginBottom: '5.7rem'
    },
    logo: {
        width: '8rem',
        height: '5.5rem',
        marginBottom: '2.8rem'
    }
}));

const EmptyStateFullPageLg = () => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <>
            <div className={classes.topContainer}>
                <div className={classes.topLeftContainer}>
                    <NoQuotesSummary className={classes.noQuotesSummaryContainer} titleClassName={classes.title} subTitleClassName={classes.subTitle} />
                    <ReviewNoticeCard className={classes.reviewNoticeCardContainer} textClassName={classes.reviewNoticeCardText} />
                </div>
                <AlexanderNoResults className={classes.alexander} />
            </div>
            <Separator type="horizontal" className={classes.separator} />
            <ProviderLogoGrid titleClassName={classes.logoTitle} logoClassName={classes.logo} />
            <FindInsurerNotice className={classes.findInsurerNoticeContainer} />
        </>
    );
};

export { EmptyStateFullPageLg };
